import * as z from 'zod'
import { CarLicensee, userOptionsStore } from '~/shared/api'
import { TaxiparkCountryEnum } from '~/shared/config/enums'
import { innCiRequiredSchema, ogrnCiRequiredSchema } from '~/shared/lib/schemas'

const baseSchema = CarLicensee.schema.pick({
  name: true,
  okpo: true,
  phoneNumber: true,
  legalAddress: true,
  freighterPermitNumber: true,
  freighterPermitExpirationDate: true,
})

const russiaSchema = baseSchema.and(
  CarLicensee.schema.pick({ inn: true, ogrn: true }),
)

const ivorySchema = baseSchema.and(
  z.object({ inn: innCiRequiredSchema, ogrn: ogrnCiRequiredSchema }),
)

export function getFormSchema() {
  return userOptionsStore.country === TaxiparkCountryEnum.CI
    ? ivorySchema
    : russiaSchema
}

export const formSchema = russiaSchema

export type TypeFormSchema = z.infer<typeof formSchema>

export type FormValues = TypeFormSchema
